<template>
    <b-modal ref="modal" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('JOBRECURRINGFORM')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('JOBNUMBER')">
                    <inputvalidation :formerror="formError" name="jobNumber">
                      <b-form-input type="number" v-model="formData.jobNumber"></b-form-input>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('BUILDING')">
                    <inputvalidation :formerror="formError" name="buildingDetailId">
                        <lbselect 
                          :empty="true"
                          :multiselect="true"
                          :list="buildingDetail.root" 
                          :total-count="buildingDetail.totalCount"
                          :pagination="buildingDetailPagination"
                          v-on:reload="getBuildingDetail()"
                          v-model="formData.buildingDetailId" 
                          value-field="buildingDetailId" 
                          :display-func="(item) => getBuildingDetailName(item)">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('USERSUBCOMPANIES')">
                    <inputvalidation :formerror="formError" name="subCompanyId">
                        <lbselect 
                          :empty="true" 
                          :list="subCompany.root" 
                          :total-count="subCompany.totalCount"
                          :pagination="subCompanyPagination"
                          v-on:reload="getSubCompany()"
                          v-model="formData.subCompanyId" 
                          value-field="subCompanyId" 
                          display-field="subCompanyName">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('FLOW')">
                    <inputvalidation :formerror="formError" name="flowId">
                        <lbselect 
                          :empty="true" 
                          :list="flow.root" 
                          :total-count="flow.totalCount"
                          :pagination="flowPagination"
                          v-on:reload="getFlow()"
                          v-model="flowPrimaryId" 
                          value-field="flowId" 
                          display-field="description">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('FLOWSEC')">
                    <inputvalidation :formerror="formError" name="flowId">
                        <lbselect 
                          :empty="true" 
                          :list="flowSec.root" 
                          :total-count="flowSec.totalCount"
                          :pagination="flowSecPagination"
                          v-on:reload="getFlowSec()"
                          v-model="flowSecId" 
                          value-field="flowId" 
                          display-field="description">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12">
                    <b-form-fieldset v-bind:label="$t('ISACTIVE')">
                        <inputvalidation :formerror="formError" name="isActive">
                            <b-form-checkbox v-model="formData.isActive" :value="1" :unchecked-value="0">{{$t('ISACTIVE')}}</b-form-checkbox>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
              </div>
            <div class="form-row">
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('STARTDATE')">
                        <inputvalidation :formerror="formError" name="startDate">                            
                            <datetimepicker type="date"
                                v-model="formData.startDate"
                                format="YYYY-MM-DD"
                                display-format="DD.MM.YYYY."
                                :simple="true"
                                :translate-method="trans">
                            </datetimepicker>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('NUMDAYSTOFINISH')">
                        <inputvalidation :formerror="formError" name="numDaysToFinish">
                            <b-form-input type="number" v-model="formData.numDaysToFinish"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
            </div>
            <div class="form-row">
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('RECURRINGTYPE')">
                        <inputvalidation :formerror="formError" name="recurringType">
                            <b-form-select :options="dateType" v-model="formData.recurringType"></b-form-select>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('RECURRINGINTERVAL')">
                        <inputvalidation :formerror="formError" name="interval">
                            <b-form-input type="number" v-model="formData.interval"></b-form-input>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
              </div>
          </div>
            <div class="text-center mt-lg">
              <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
          </div>
        </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/job_recurring/JobRecurring.js';
import FlowApi from '@/api/flow/FlowOperatorObligations.js';
import FlowSecApi from '@/api/flow/FlowTrafficSafetyManagment.js';
import SubcompanyApi from '@/api/admin/UserSubCompanies'
import BuildingDetailApi from '@/api/building_detail/BuildingDetail.js';
import UserApi from '@/api/admin/Users'
import localTranslate from '../../helpers/local_trans';


export default
{
    name: 'JobForm',
    props: ['value', 'stepId', 'flowId'],
    data()
    {
        const me = this;

        return {
            buildingDetail: {},
            companyWorker: {},
            subCompany: {},
            flow: {},
            flowSec: {},
            formError: {},
            formData: null,
            flowId: null,
            flowPrimaryId: null,
            flowSecId: null,
            triggerWatch: true,
            dateType:
            [
                {
                    value: 'days',
                    text: me.$i18n.t('DAYS')
                },
                {
                    value: 'weeks',
                    text: me.$i18n.t('WEEKS')
                },
                {
                    value: 'months',
                    text: me.$i18n.t('MONTHS')
                },
                {
                    value: 'years',
                    text: me.$i18n.t('YEARS')
                }
            ],
            buildingDetailPagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
            companyWorkerPagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
            flowPagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
            flowSecPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
            subCompanyPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        trans(key)
        {
            const me = this;
            return localTranslate(me.globals.langId, key);
        },
        getBuildingDetailName(item)
        {
            let str = `${item.clientName} ${item.address}`;
            return str;
        },
        getCompaynWorkerName(item)
        {
            let str = `${item.name} ${item.surname}`;
            return str;
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.jobReccuringId !== 'undefined')
                {
                    item.id = item.jobReccuringId;
                    delete (item.jobReccuringId);
                }

                item.flowId = me.flowId;
                const data = await Api.save(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
              console.log(e);
                me.$notify.notice(e);
            }
        },
        async getSubCompany()
        {
            const me = this;
            try
            {
                const data = await SubcompanyApi.selectRow(me.getSubCompanyParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.subCompany = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getBuildingDetail()
        {
            const me = this;
            try
            {
                const data = await BuildingDetailApi.selectRow(me.getBuildingDetailParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.buildingDetail = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getUsers()
        {
            const me = this;
            try
            {
                const data = await UserApi.selectRow(me.getCompanyWorkerParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }

                for(var i=0;i<data.root.length;i++)
                {
                    data.root[i].password = '';
                    data.root[i].trhidden = false;
                }

                me.companyWorker = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getFlow()
        {
            const me = this;
            try
            {
                const data = await FlowApi.selectRow(me.getFlowParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.flow = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getFlowSec()
        {
            const me = this;
            try
            {
                const data = await FlowSecApi.selectRow(me.getFlowSecParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.flowSec = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.flowId = null;
            me.flowPrimaryId = null;
            me.flowSecId = null;
            me.$emit('close');
        },
    },
    watch:
    {
        flowPrimaryId(val)
        {
            const me = this;
            if (me.triggerWatch)
            {
                me.triggerWatch = false;
                me.flowSecId = null;
                me.flowId = val;
            }
            setTimeout(() =>
            {
                me.triggerWatch = true;
            }, 500);
            
        },
        flowSecId(val)
        {
            const me = this;
            if (me.triggerWatch)
            {
                me.triggerWatch = false;
                me.flowPrimaryId = null;
                me.flowId = val;
            }
            setTimeout(() =>
            {
                me.triggerWatch = true;
            }, 500);
            
        },
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getSubCompany();
                await me.getBuildingDetail();
                await me.getUsers();
                await me.getFlow();
                await me.getFlowSec();

                if (val.flowId != null)
                {
                    const inPrimary = me.flow.root && me.flow.root.some(f => f.flowId === val.flowId);
                    const inSec = me.flowSec.root && me.flowSec.root.some(f => f.flowId === val.flowId);
                    
                    if (inPrimary)
                    {
                        me.flowPrimaryId = val.flowId;
                    }
                    else if (inSec)
                    {
                        me.flowSecId = val.flowId;
                    }
                }

                if ((val.jobStartDate != null && val.jobStartDate !== '')
                    || (val.jobEndDate != null && val.jobEndDate !== ''))
                {
                    me.showPeriod = 1;
                }
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getBuildingDetailParams()
      {
          const me = this;
          const data = { ...me.buildingDetailPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getCompanyWorkerParams()
      {
          const me = this;
          const data = { ...me.companyWorkerPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getFlowParams()
      {
          const me = this;
          const data = { ...me.flowPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getFlowSecParams()
      {
          const me = this;
          const data = { ...me.flowSecPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
    },
};
</script>
